'use client';

import dynamic from 'next/dynamic';

import { type PushNotificationsPrePromptModalProps } from './push-notifications-pre-prompt-modal';

const PushNotificationsPrePromptModal = dynamic(
  async () => {
    const { PushNotificationsPrePromptModal: Component } =
      await import('./push-notifications-pre-prompt-modal');
    return { default: Component };
  },
  { ssr: false }
);

export const PushNotificationsPrePromptModalLoader = (
  props: PushNotificationsPrePromptModalProps
) => {
  if (!props.isOpen) return null;

  return <PushNotificationsPrePromptModal {...props} />;
};
